export default {
  SET_VALUE_REQUEST_ID_VALUE: 'SET_VALUE_REQUEST_ID_VALUE',

  GET_COMPONENTS_REQUEST: 'GET_COMPONENTS_REQUEST',
  GET_COMPONENTS_SUCCESS: 'GET_COMPONENTS_SUCCESS',
  GET_COMPONENTS_FAILURE: 'GET_COMPONENTS_FAILURE',

  GET_COUPONS_REQUEST: 'GET_COUPONS_REQUEST',
  GET_COUPONS_SUCCESS: 'GET_COUPONS_SUCCESS',
  GET_COUPONS_FAILURE: 'GET_COUPONS_FAILURE',

  GET_SLIP_REQUEST: 'GET_SLIP_REQUEST',
  GET_SLIP_SUCCESS: 'GET_SLIP_SUCCESS',
  GET_SLIP_FAILURE: 'GET_SLIP_FAILURE',
};
